import { TypedEventEmitterV3 } from "@moopsyjs/toolkit";
export class ReadableMoopsyStream {
    constructor(input, mutationCall, client) {
        this.mutationCall = mutationCall;
        this.client = client;
        this.emitter = new TypedEventEmitterV3();
        this.onData = (cb) => {
            this.emitter.on("data", cb);
            return this;
        };
        this.onEnd = (cb) => {
            this.emitter.on("end", cb);
            return this;
        };
        this.id = input.id;
        this.client.incomingMessageEmitter.on(`response.${mutationCall.callId}.${this.id}`, (data) => {
            this.emitter.emit("data", data.backlog);
            if (data.ended) {
                this.emitter.emit("end", null);
            }
        });
    }
}
